import { combineReducers } from "redux";
import CommonReducer from "./CommonReducer";
const rootReducer = combineReducers({
  CommonReducer,
});

export default rootReducer;
